/** @format */

import React from 'react';
import Breadcrumb from 'src/components/Breadcrumb';
import { useTranslation } from 'react-i18next';
import SelectComponent from 'src/components/select';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Chip, Button, IconButton } from '@material-ui/core';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import TransitEnterexitIcon from '@material-ui/icons/TransitEnterexit';

const OPTIONS = [
  {
    name: 'Option 1'
  },
  {
    name: 'Option 2'
  },
  {
    name: 'Option 3'
  }
];

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: '1.5rem',
    maxWidth: '70%',
    margin: '2rem auto 0 auto'
  },
  chip: {
    background: 'rgba(0, 0, 0, 0.15)',
    color: '#000',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '13px',
    lineHeight: '17px'
  },
  deleteButton: {
    marginLeft: '1rem',
    color: '#8D8D8D',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '16px'
  },
  iconButton: {
    color: '#000',
    fontSize: '14px'
  },
  iconButton2: {
    color: '#000',
    fontSize: '14px',
    transform: 'rotate(180deg)'
  }
}));

const SavedItems = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const breadcrumbData = [
    {
      title: t('menu.savedItems')
    }
  ];

  const savedItemsData = [
    {
      title: 'My E-Learning collection',
      subTitle: 'in My Learning',
      type: 'Collection'
    },
    {
      title: 'My E-Learning collection',
      subTitle: 'in My Learning',
      type: 'Content'
    },
    {
      title: 'My E-Learning collection',
      subTitle: 'in My Learning',
      type: 'Type'
    }
  ];

  const SavedItem = ({ data }) => {
    const getIconButton = () => {
      if (data?.type === 'Collection') {
        return (
          <IconButton className={classes.iconButton2}>
            <TransitEnterexitIcon />
          </IconButton>
        );
      }
      return (
        <IconButton className={classes.iconButton}>
          <KeyboardArrowRightIcon />
        </IconButton>
      );
    };
    return (
      <>
        <div className={'saved-item-box'}>
          <div className="saved-item-description">
            <span className="saved-item-title">{data?.title}</span>
            <span className="saved-item-sub-title">{data?.subTitle}</span>
          </div>
          <div>
            <Chip className={classes.chip} label={data?.type} />
            {data?.type !== 'Collection' && <Button className={classes.deleteButton}>Delete</Button>}
            {getIconButton()}
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Breadcrumb data={breadcrumbData} />
      <div className="container">
        <div className="welcome-title">
          <h2 className="uppercase">{`${t('menu.savedItems')} (${32})`}</h2>
        </div>

        <div>
          <SelectComponent label="TYPE" options={OPTIONS} />
          <SelectComponent label="LOCATION/ PORTAL" options={OPTIONS} />
        </div>

        <Grid container className={classes.root} spacing={2}>
          {savedItemsData?.map(item => (
            <>
              <Grid item sm={12}>
                <SavedItem data={item} />
              </Grid>
            </>
          ))}
        </Grid>
      </div>
    </>
  );
};

export default SavedItems;
